import { useContext } from 'react'

import { UserContext } from '@/modules/auth/context.ts'

export const useUser = () => {
  return useContext(UserContext)
}
